import React from 'react';

export const Alert = ({ warning, error, children }) => (
  <div css={{
    padding: "2rem",
    marginTop: "3rem",
    marginBottom: "3rem",
    borderRadius: "0.25rem",
    backgroundColor: warning ? "rgb(245 158 11)" : error ? "rgb(239 68 68)" : "",
  }}>
    {children}
  </div>
);

export default Alert;
